/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */
import { makeStyles } from "@material-ui/core";

export const useDrawerProviderV1Styles = makeStyles(() => {
    return {
        fullWidth: {
            width: "auto",
        },
        root: {
            maxWidth: 400,
        },
    };
});
